import React from 'react';

export default function CopyIcon() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M17.9773 6.46154H16.7045V5.23077C16.7045 4.55385 16.1318 4 15.4318 4H6.52273C5.82273 4 5.25 4.55385 5.25 5.23077V16.3077C5.25 16.9846 5.82273 17.5385 6.52273 17.5385H7.79545V18.7692C7.79545 19.4462 8.36818 20 9.06818 20H17.9773C18.6773 20 19.25 19.4462 19.25 18.7692V7.69231C19.25 7.01538 18.6773 6.46154 17.9773 6.46154ZM7.79545 7.69231V16.3077H6.52273V5.23077H15.4318V6.46154H9.06818C8.36818 6.46154 7.79545 7.01538 7.79545 7.69231ZM17.9773 18.7692H9.06818V7.69231H17.9773V18.7692Z" fill="currentColor"/>
    </svg>
  );
}